<template>
  <div  class="classtj-div"  @click="goDetail()">
    <div>
      <el-image :src="this.hylzurl" style="width: 50%;margin-top: 9vh;margin-left: 12vw">
      </el-image>
    <button style="margin-left:11vw;margin-right:11vw; text-align:left;height: 32vh">
      <font  color="#FFFDD0" size="4px">{{this.userInfo.lastLeagueName}}</font>
      <font color="#FDBE00" size="4px"> 团支部的 </font>
      <font color="#FFFDD0" size="4px">{{this.userInfo.nickname}}<br></font>
      <font color="#FDBE00" size="4px">参与本期青年大学习,<br></font>
      <font  color="#FDBE00" size="4px">让我们一起在学习中进步,<br></font>
      <font  color="#FDBE00" size="4px">在进步中升华！</font>
    </button>
    </div>
    <div style="text-align:center;margin-top: 33vh">
<!--      <button style="margin-top: 49vh; text-align:center;margin-left: 28vw;margin-right: 12vw">-->
      <button style="height: 5vh">
        <font color="#FDBE00" size="6px">{{this.className}}<br></font>
        <font color="#0000cd" size="3px"> 点击任意位置开始学习 </font>
      </button>
    </div>
  </div>
</template>

<script>
import {getUser} from "@api/user";
import $store from "@/store";
import {submitLession} from "@api/lesson";

export default {
  name: "GoodsClass",
  props: {},
  data: function () {
    return {
      userInfo: {},
      tbUser: {},
      classId:this.$route.query.classId,
      url:this.$route.query.url,
      className:this.$route.query.className,
      hylzurl: require("@assets/images/hylz.png")
    };
  },
  mounted: function () {
    console.log(this.$route.query.url)
    this.url=this.$route.query.url
    console.log(this.$route.query.classId)
    this.classId=this.$route.query.classId
    this.User();
    document.addEventListener("scroll", this.onScroll, false);
  },
  methods: {
    User: function () {
      let that = this;
      getUser().then(res => {
        try {
          console.log("用户信息：");
          that.userInfo = res.data;
          that.tbUser=that.userInfo.tbUser;
          // console.log(that.userInfo);
        } catch (e) {
          $store.commit("LOGOUT");
        }
      });
    },
    goDetail() {
      console.log("url:" + this.url);
      var params = {
          classId: this.classId,
          url:this.url
      }
      submitLession(params).then(response => {
          console.log(response.rsp)
          if(this.url!==""){
              if (response.rsp === "false") {
                  this.$message.warning('请刷新页面并完成团组织绑定！');
              } else {
                  window.location.href = this.url
              }

          }else{
              this.$message.warning('新的一期课程发布中,请等待！');
              console.log(console.log(this.url))
          }
      window.open(this.url, "_self","toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=no, resizable=no, copyhistory=yes, width=400, height=400");
      });
      // window.open(this.url, "_self");
    }
  },
  beforeDestroy: function () {
    document.removeEventListener("scroll", this.onScroll, false);
  }
};
</script>

<style>
.ipt_num {
  width: 100%;
  display: block;
  line-height: 0.44rem;
  text-align: center;
}

.xxpd_bg {
  text-align: center;
  /*background-image: linear-gradient(-180deg, #f86d6d 0%, #ff2323 100%);*/
  /*background-image: radial-gradient(circle, #f86d6d, #ff2323);*/
  background-image: url("../assets/images/classChannel/jfsc.jpg");
  /*background-repeat: no-repeat;*/
  background-size: 100% 100%; /*按比例缩放*/
  height: 100%;
}

.last-img {
  height: 35vh;
  width: 100%;
  position: relative;
  text-align: center;
  background-size: 100% 100%; /*按比例缩放*/
  background-image: url("../assets/images/classChannel/1.jpg");
  margin: 0px;
}

.classtj-div {
  width: 100% !important;
  height: 100% !important;
  text-align: left !important;
  background-size: 100% 100% !important; /*按比例缩放*/
  background-image: url("../assets/images/class-tz.jpg");
}

.gz-button {
  margin-right: 55vw !important;
  margin-top: 10vh !important;
  width: 100% !important;
  height: 5vw !important;
  text-align: center !important;
  line-height: 1vw !important;
  background-color: #5af4fe;
}

.score-bar {
  margin-top: 1vh;
  margin-left: 10vw;
  text-align: left;
  font-size: small;
  color: #f8f8f8;
  font-weight: bold;
  text-shadow: 2px 2px 4px #000000;
}
.score-bar-ypt {
  margin-top: 1vh;
  margin-left: 40vw;
  text-align: left;
  font-size: small;
  color: #f8f8f8;
  font-weight: bold;
  text-shadow: 2px 2px 4px #000000;
}
.order-bar {
  margin-right: 3vw;
  text-align: right;
  font-size: small;
  color: #f8f8f8;
  font-weight: bold;
  text-shadow: 2px 2px 4px #000000;
}
</style>
